import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'
import { Base64 } from 'js-base64'

const util = {
  cookies,
  db,
  log
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText, flag) {
  const processTitle = flag === true ? (process.env.VUE_APP_TITLE || '') : ''
  window.document.title = `${processTitle}${flag ? ' | ' : ''}${titleText || ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

util.tree = function (data) {
  // 删除 所有 children,以防止多次调用
  data.forEach(function (item) {
    delete item.children
  })
  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  var map = {}
  data.forEach(function (item) {
    map[item.id] = item
  })
  //        console.log(map);
  var val = []
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    var parent = map[item.pid]
    // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      (parent.children || (parent.children = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}
// ucs-2 string to base64 encoded ascii
util.encode64 = function (str) {
  return Base64.encode(str)
}
// base64 encoded ascii to ucs-2 string
util.decode64 = function (str) {
  return Base64.decode(str)
}
util.stringToJson = function (strJson, defaultValue = null) {
  try {
    // eslint-disable-next-line
    return eval('(' + strJson + ')')
  } catch {
    return defaultValue
  }
}
util.stringToFun = function (strFun) {
  try {
    // eslint-disable-next-line
    return eval(strFun)
  } catch {
    return () => { }
  }
}

util.transitionHospital = function(deptList) {
  var hospitalList = []
  var temHospitalId
  for (var i = 0; i < deptList.length; i++) {
    var hospitalId = deptList[i].hospital_Id
    if (i === 0) {
      hospitalList.push({
        id: hospitalId,
        name: deptList[i].hospital_name,
        dept: [{ id: deptList[i].dept_id, name: deptList[i].dept_name }]
      })
    } else {
      if (temHospitalId === hospitalId) {
        hospitalList[0].dept.push({
          id: deptList[i].dept_id,
          name: deptList[i].dept_name
        })
      } else {
        hospitalList.push({
          id: hospitalId,
          name: deptList[i].hospital_name,
          dept: [{ id: deptList[i].dept_id, name: deptList[i].dept_name }]
        })
      }
    }
    temHospitalId = hospitalId
  }
  return hospitalList
}

export default util
